module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/view-scal360-activation-history/view-scal360-activation-history.component.css
// module id = 994
// module chunks = 1